import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeDataTables, getTableTitle, getParentTitle} from '../utils/utils';
import { Menu, Icon } from 'antd';
import { startSetDataTable, startSetDataTableCustom } from '../actions/globalState';
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

export class DetailMenu extends React.Component {
  static propTypes = {
    data_table: PropTypes.object,
    data_tables: PropTypes.array,
  };

  handleClick = (e) => {
    //console.log('click ', e.item.props);
    const data_table = {
      display_name: e.item.props.display_name,
      table_ending: e.item.props.table_ending,
      table_group: e.item.props.table_group,
      chart_order_clause: e.item.props.chart_order_clause,
      chart_heading: e.item.props.chart_heading,
      about_text: e.item.props.about_text,
      summary_heading: e.item.props.summary_heading,
      summary_content: e.item.props.summary_content,
      summary_sort: e.item.props.summary_sort,
      show_table_comparisons: e.item.props.show_table_comparisons,
      show_table_percentage: e.item.props.show_table_percentage,
      show_tab_summary: e.item.props.show_tab_summary,
      show_tab_chart: e.item.props.show_tab_chart,
      show_tab_table: e.item.props.show_tab_table,
      show_tab_about: e.item.props.show_tab_about,
      custom: e.item.props.custom
    }
    if (e.item.props.custom ===0) {
      this.props.startSetDataTable(data_table);
    } else {
      this.props.startSetDataTableCustom(data_table);
    }

  }
  tree = makeDataTables(this.props.data_tables)
  rootSubmenuKeys = getTableTitle(this.tree);

  state = {
    openKeys: [this.props.data_table.table_group]
  };

  onOpenChange = (openKeys) => {
    //console.log('rootSubmenuKeys', this.rootSubmenuKeys);
    const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys });
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [],
      });
    }
  }
 
  render() {
    if (this.props.data_table === undefined || this.props.data_tables === undefined) {
      return (<div></div>)
    }
    return (
      <Menu
        onClick={this.handleClick}
        //openKeys={[this.props.data_table.table_group]}
        openKeys={this.state.openKeys}
        onOpenChange={this.onOpenChange}
        defaultSelectedKeys={[this.props.data_table.display_name]}
        //defaultOpenKeys={[this.props.data_table.table_group]}
        mode="inline"
      >
        {
          this.tree.map((item, index) => {
            return (
              <SubMenu key={item.title} title={<span>{item.title}</span>}>
                {
                  item.children.map((subItem, subIndex) => {
                    return (
                        <Menu.Item key={subItem.title} display_name={subItem.title} 
                        table_ending={subItem.value} table_group={subItem.group} 
                        chart_heading={subItem.chart_heading} 
                        chart_order_clause={subItem.chart_order_clause}
                        about_text={subItem.about_text}
                        summary_content={subItem.summary_content}
                        summary_heading={subItem.summary_heading}
                        summary_sort={subItem.summary_sort ? 1 : 0}
                        show_table_comparisons={subItem.show_table_comparisons ? 1 : 0}
                        show_table_percentage={subItem.show_table_percentage ? 1 : 0}
                        show_tab_summary= {subItem.show_tab_summary ? 1 : 0}
                        show_tab_chart= {subItem.show_tab_chart ? 1 : 0}
                        show_tab_table= {subItem.show_tab_table ? 1 : 0}
                        show_tab_about= {subItem.show_tab_about ? 1 : 0}
                        custom= {subItem.custom ? 1 : 0}
                        >{subItem.title} </Menu.Item>
                    )
                  })
                }
              </SubMenu>
            )
          })
        }

      </Menu>
    );
  }
}

const mapStateToProps = (state) => ({
  data_table: state.globalState.data_table,
  data_tables: state.globalState.data_tables
});

const mapDispatchToProps = (dispatch) => ({
  startSetDataTable: (text) => dispatch(startSetDataTable(text)),
  startSetDataTableCustom: (text) => dispatch(startSetDataTableCustom(text)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailMenu);



// WEBPACK FOOTER //
// ./src/components/DetailMenu.js